import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './updated/App/App';

const root = ReactDOM.createRoot( document.getElementById( 'app-root' ) );

root.render( <App /> );
